import { Form, Input } from "antd";
import CloseIcon from "../../../../../assets/icons/CloseIcon";
import { QuestionTypeProps } from "../_types/type";

export default function DropdownField({ index }: QuestionTypeProps) {
  return (
    <Form.List name={[index, "question_choices"]} initialValue={["Option 1"]}>
      {(choices, { add, remove }) => (
        <>
          {choices.map((choiceField, idx) => (
            <div key={choiceField.key} className="flex items-center gap-2 mt-4">
              <span className="text-display-body text-sm font-medium">
                {idx + 1}.
              </span>
              <Form.Item
                name={[choiceField.name]}
                className="flex-1 mb-0"
                rules={[
                  {
                    required: true,
                    message: "Option is required",
                  },
                ]}
                initialValue={`Option ${idx + 1}`}
              >
                <Input
                  placeholder={`Option ${idx + 1}`}
                  className="!border-x-0 !border-t-0 !rounded-none !border-b-light !shadow-none"
                />
              </Form.Item>
              {choices?.length > 1 && (
                <span
                  onClick={() => remove(choiceField.name)}
                  className="text-status-dark-text cursor-pointer"
                >
                  <CloseIcon />
                </span>
              )}
            </div>
          ))}
          <div className="flex items-center gap-2 mt-4">
            <span className="text-display-body text-sm font-medium">
              {choices.length + 1}.
            </span>
            <div className="text-sm font-medium text-display-dark pl-2">
              Add option or{" "}
              <button
                className="text-primary"
                onClick={() => add()}
                type="button"
              >
                add “More”
              </button>
            </div>
          </div>
        </>
      )}
    </Form.List>
  );
}
